<template>

    <b-alert
            :show="dismissCountDown"
            dismissible
            fade
            :variant="variantAlert"
            @dismiss-count-down="countDownChanged"
    >
        {{ textAlert }}
    </b-alert>

</template>

<script>

    import { mapGetters } from "vuex";
    export default {
        name: "Alert",

        computed: {
            ...mapGetters({
                textAlert: 'gettersTextAlert',
                variantAlert: 'gettersVariantAlert',
                type: 'gettersTypeAlert',
                run: 'gettersRunAlert'
            }),
        },

        data () {
            return{
                dismissSecs: 4,
                dismissCountDown: 0,
                showDismissibleAlert: false,

                toastCount: 0
            }
        },

        methods: {
            countDownChanged(dismissCountDown) {
                this.dismissCountDown = dismissCountDown
            },

            makeToast() {
                this.toastCount++
                this.$bvToast.toast(this.textAlert, {
                    title: this.title(),
                    toaster: 'b-toaster-top-center',
                    variant: this.variantAlert,
                    autoHideDelay: 5000,
                    solid: true
                })
            },


            title(){
                if (this.variantAlert === 'success'){
                    return 'Успешно'
                } else if (this.variantAlert === 'warning'){
                    return 'Предупреждение'
                } else if (this.variantAlert === 'danger'){
                    return 'Ошибка'
                } else if (this.variantAlert === 'primary'){
                    return 'Уведомление'
                }
            }


        },

        watch:{
            run: function() {

                if (this.type === 'toast'){
                    this.makeToast()
                } else {
                    this.dismissCountDown = this.dismissSecs;
                }


            }
        }

    }
</script>

<style >

    .b-toast-success .toast{
        background-color: #00a044!important;
        border-color: #00a044!important;
        color: #ffffff;
    }

    .b-toast-success .toast .toast-header {
        color: #ffffff;
        background-color: #00a044!important;
        border-bottom-color: #00a044!important;
        font-size: 14px;
    }

    .b-toast-danger .toast{
        background-color: #f64e60!important;
        border-color: #f64e60!important;
        color: #ffffff;
    }

    .b-toast-danger .toast .toast-header {
        color: #ffffff;
        background-color: #f64e60!important;
        border-bottom-color: #f64e60!important;
        font-size: 14px;
    }

    .b-toast-warning .toast{
        background-color: #ffd97a!important;
        border-color: #ffd97a!important;
        color: #030303;
    }

    .b-toast-warning .toast .toast-header {
        color: #030303;
        background-color: #ffd97a!important;
        border-bottom-color: #ffd97a!important;
        font-size: 14px;
    }

    .b-toast-primary .toast{
        background-color: #3699ff!important;
        border-color: #3699ff!important;
        color: #ffffff;
    }

    .b-toast-primary .toast .toast-header {
        color: #ffffff;
        background-color: #3699ff!important;
        border-bottom-color: #3699ff!important;
        font-size: 14px;
    }

    .b-toast .toast .toast-body {
        display: block;
        font-size: 14px;
    }

    .toast-header strong {
        margin-top: 0.5rem;
    }






</style>